// Pure helpers for the in-app "News" (changelog) bell and modal.

// An entry counts as unseen when its PUSH time (created_at, set when the
// webmag-os skill inserts the row) is newer than BOTH the user's last
// "news seen" timestamp and the user's registration date — fresh
// accounts must not get old news popped up on first login. We compare
// created_at, not published_at: published_at is a plain date (UTC
// midnight), so a same-day afternoon push would never outrank a morning
// "seen" timestamp. created_at does not change on correction upserts.
export function isEntryUnseen(entry, changelogSeenAt, userCreatedAt) {
  const thresholds = [changelogSeenAt, userCreatedAt]
    .filter(Boolean)
    .map((value) => new Date(value).getTime());
  if (thresholds.length === 0) return true;
  return new Date(entry.created_at).getTime() > Math.max(...thresholds);
}

export function hasUnseenEntries(entries, changelogSeenAt, userCreatedAt) {
  if (!entries || entries.length === 0) return false;
  return entries.some((entry) => isEntryUnseen(entry, changelogSeenAt, userCreatedAt));
}

export function localizeEntry(entry, languageHandle) {
  const isGerman = languageHandle === 'de';
  return {
    slug: entry.slug,
    publishedAt: entry.published_at,
    version: entry.version,
    category: entry.category,
    title: isGerman ? entry.title_de : entry.title_en,
    teaser: isGerman ? entry.teaser_de : entry.teaser_en,
    helpUrl: entry.help_url,
    imageUrl: entry.image_url || null,
  };
}
